import React from 'react'
import clsx from 'clsx'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import Typography from 'components/Typography'
import Tooltip from 'components/Tooltip'
import stylesGlobal from 'stylesGlobal.module.scss'

export type LabelInfoProps = {
  className?: string
  component?: 'div' | 'span'
  title: string
  titleTooltip?: React.ReactNode | string
  content: React.ReactNode | string
}

const LabelInfo: React.FC<LabelInfoProps> = props => {
  const { className, component: Component = 'div', content, title, titleTooltip } = props

  return (
    <Component className={clsx(className)}>
      <div
        className={clsx(
          stylesGlobal.DisplayFlex,
          stylesGlobal.AlignItemsCenter,
          stylesGlobal.MarginBottom4,
          stylesGlobal.TextColorLight
        )}
      >
        <Typography variant="body1" component="h3">
          {title}
        </Typography>

        {titleTooltip ? (
          <Tooltip
            className={clsx(
              stylesGlobal.HeightFull,
              stylesGlobal.MarginLeft8,
              stylesGlobal.PointerEventsAuto
            )}
            title={titleTooltip}
          >
            <HelpOutlineIcon
              className={clsx(stylesGlobal.TextColorLight, stylesGlobal.FontSize16)}
            />
          </Tooltip>
        ) : null}
      </div>

      <Typography variant="h5" component="div" fontWeight="extraBold">
        {content}
      </Typography>
    </Component>
  )
}

export default LabelInfo
